export const SERVER_URL = "https://api.traderforum.in"; //process.env.BACKEND_URL;
export const FRONTEND_URL = "https://traderforum.in"; //process.env.FRONTEND_URL;
